import { render } from "./DataSourcesOnvifAuth.vue?vue&type=template&id=08316689&ts=true"
import script from "./DataSourcesOnvifAuth.vue?vue&type=script&lang=ts"
export * from "./DataSourcesOnvifAuth.vue?vue&type=script&lang=ts"

import "./DataSourcesOnvifAuth.vue?vue&type=style&index=0&id=08316689&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__